<template>
    <div>
        <b-table
            id="cdas"
            :items="resultado"
            :fields="fields"
            striped
            small
            responsive="sm"
            :no-local-sorting="true"
            @sort-changed="sortingChanged"
            :busy="configTable.load"
            show-empty
            >
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>
            <template slot="empty">
                <p class="my-auto">Nenhuma dívida com exceção encontrada.</p>
            </template>
            <template slot="HEAD_selecionar">
                <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
            </template>
            <template slot="HEAD_11">
                <p class="no-line m-0 p-0">Motivo</p>
            </template>
            <template slot="selecionar" slot-scope="row">
                <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(row.item)" @change="toggleCheck($event, row.item)" />
            </template>
            <template slot="1" slot-scope="row">
                <b-link @click="abrirModalExtratoCda(row.item.codCdaSefa)" class="m-0 p-0 text-center">
                    <p class="m-0 p-0"> {{ row.item.numeroDivida }} </p>
                </b-link>
            </template>
            <template slot="2" slot-scope="row">
                {{ row.item.contribuinte }}
                <template v-for="c in row.item.outrosContribuintes">
                    <br :key="c.codDevedor" />
                    {{ c.contribuinte }}
                </template>
            </template>
            <template slot="3" slot-scope="row">
                {{ row.item.cpfCnpj | cpfCnpj }}
                 <template v-for="c in row.item.outrosContribuintes">
                    <br :key="c.codDevedor" />
                    {{ c.cpfCnpj | cpfCnpj }}
                </template>
            </template>
            <template slot="4" slot-scope="row">
                {{ row.item.comarca }}
            </template>
            <template slot="5" slot-scope="row">
                {{ row.item.tipoCredito }}
            </template>
            <template slot="6" slot-scope="row">
                {{ row.item.valor | currency }}
            </template>
            <template slot="7" slot-scope="row">
                {{ row.item.cadicms }}
            </template>
            <template slot="8" slot-scope="row">
                {{ row.item.dtInscricao }}
            </template>
            <template slot="9" slot-scope="row">
                {{ row.item.statusFIR }}
            </template>
            <template slot="10" slot-scope="row">
                {{ row.item.dtAtualizacao }}
            </template>
            <template slot="11" slot-scope="row">
                {{ row.item.motivo }}
            </template>
        </b-table>

        <ExtratoCda
            ref="extratoCda"
            @closeModal="closeModal" />
    </div>
</template>

<script>
import ExtratoCda from "../../shared/components/ExtratoCda";
export default {
    components: {ExtratoCda},
    props: ['resultado', 'fields', 'configTable', 'selecteds'],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false
            this.$emit('consultarDividas')
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el)) {
                        this.selecteds.push(el)
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el)) {
                        const index = this.selecteds.indexOf(el)
                        this.selecteds.splice(index, 1)
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked
                this.selecteds.push(item)
            } else {
                item.checked = checked
                const index = this.selecteds.indexOf(item)
                this.selecteds.splice(index, 1)
                this.configTable.checkedAll = false
            }
        },
        sortingChanged(ctx) {
            if(ctx.sortBy == 1) {
                this.configTable.sortField = 'numeroDivida'
            }
            if(ctx.sortBy == 2) {
                this.configTable.sortField = 'contribuinte'
            }
            if(ctx.sortBy == 3) {
                this.configTable.sortField = 'cpfCnpj'
            }
            if(ctx.sortBy == 4) {
                this.configTable.sortField = 'comarca'
            }
            if(ctx.sortBy == 5) {
                this.configTable.sortField = 'tipoCredito'
            }
            if(ctx.sortBy == 6) {
                this.configTable.sortField = 'valorTotal'
            }
            if(ctx.sortBy == 7) {
                this.configTable.sortField = 'cadiCms'
            }
            if(ctx.sortBy == 8) {
                this.configTable.sortField = 'dataInscricao'
            }
            if(ctx.sortBy == 9) {
                this.configTable.sortField = 'motivo'
            }
            this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.$emit('sortingChanged')
        },
        abrirModalExtratoCda(codCdaSefa) {
            this.$refs['extratoCda'].abrirExtrato(codCdaSefa);
        },
        closeModal() {
            this.$refs['extratoCda'].fecharModais();
        },
    }

}
</script>

<style scoped>
.no-line {
    white-space: nowrap;
}
</style>
